import { render } from "./SectionPartnerReference.vue?vue&type=template&id=93b2cb8e&scoped=true"
import script from "./SectionPartnerReference.vue?vue&type=script&lang=js"
export * from "./SectionPartnerReference.vue?vue&type=script&lang=js"

import "./SectionPartnerReference.vue?vue&type=style&index=0&id=93b2cb8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b2cb8e"]])

export default __exports__